import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ErrorMessage from '../../components/errormessage';
import PartnerForm from '../../components/super/partnerEdit';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { useStores } from '../../hooks/use-stores';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

function PartnerEdit() {
    let { partnerId, parentPartnerId } = useParams();
    const { superStore } = useStores();
    const navigate = useNavigate();
    const { savingPartner, error, partnerEditForm: partnerForm } = superStore;
    const { pathname } = useLocation();
    const isSubPartnerCreate = !!parentPartnerId;
    const isCreate = pathname.includes('create');

    const loadData = async () => {
        if (partnerId && !isSubPartnerCreate) {
            await superStore.loadPartner(partnerId);
        }
    };

    useEffect(() => {
        const onSave = (result) => {
            if (isSubPartnerCreate && result && result.id) {
                navigate(`/partners/${result.id}`);
            } else {
                navigate('/partners');
            }
        };
        superStore.startEditPartner(
            isSubPartnerCreate ? null : partnerId,
            onSave,
            parentPartnerId || null
        );
        loadData();
    }, [partnerId, parentPartnerId]);

    return (
        <Grid
            container
            direction="row"
            justify="center"
            align="center"
            spacing={2}
        >
            <Grid item xs={12}>
                <Box mt={4}>
                    <Typography variant="h2" gutterBottom>
                        {isSubPartnerCreate
                            ? 'Create distributor'
                            : isCreate
                              ? 'Create partner'
                              : 'Edit partner'}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                {partnerForm && <PartnerForm form={partnerForm} />}
            </Grid>
            <Grid item xs={12}>
                {savingPartner ? (
                    <ThemedSpinner />
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => partnerForm.onSubmit(e)}
                    >
                        Save
                    </Button>
                )}
            </Grid>
            {error && (
                <Grid item xs={12}>
                    <ErrorMessage error={error} />
                </Grid>
            )}
        </Grid>
    );
}

export default observer(PartnerEdit);
